/**
 * @GENERATED from Figma node 3638:51806
 */

import * as React from "react";
export type IconProps = Omit<React.SVGProps<SVGSVGElement>, "color">;
const ServiceNowDark = (props: IconProps, ref: React.Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    focusable={false}
    role="presentation"
    ref={ref}
    {...props}
  >
    <path
      fill="#62D84E"
      fillRule="evenodd"
      d="M12.06 3.003a10 10 0 0 0-5.645 1.733 10.1 10.1 0 0 0-3.7 4.626 10.17 10.17 0 0 0-.48 5.92 10.1 10.1 0 0 0 2.908 5.168 1.976 1.976 0 0 0 2.578.134 7.14 7.14 0 0 1 4.28-1.426c1.54 0 3.041.5 4.278 1.426a1.98 1.98 0 0 0 2.593-.152 10.1 10.1 0 0 0 2.89-5.14 10.16 10.16 0 0 0-.459-5.887 10.1 10.1 0 0 0-3.65-4.624A10 10 0 0 0 12.06 3M12 18.146a4.84 4.84 0 0 1-3.573-1.433 4.9 4.9 0 0 1-1.424-3.596c0-1.334.526-2.613 1.463-3.557A4.98 4.98 0 0 1 12 8.087c1.326 0 2.597.53 3.534 1.473a5.05 5.05 0 0 1 1.464 3.557 4.93 4.93 0 0 1-1.425 3.596A4.87 4.87 0 0 1 12 18.146"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = React.forwardRef(ServiceNowDark);
export { ForwardRef as ServiceNowDark };
